import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Instagram, Twitter, Facebook } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    setSubscribed(true);
    setEmail('');
    setTimeout(() => setSubscribed(false), 3000);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <motion.div
          className="footer-brand"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h3 className="footer-logo">NIRUPRINT SOLUTIONS</h3>
          <p className="footer-description">
            Your trusted partner for custom cardboard printing and binding, delivering high-quality solutions to businesses across the UK.
          </p>
          <div className="footer-social">
            <motion.a
              href="https://instagram.com"
              target="_blank"
              whileHover={{ scale: 1.2 }}
              aria-label="Instagram"
            >
              <Instagram size={24} />
            </motion.a>
            <motion.a
              href="https://twitter.com"
              target="_blank"
              whileHover={{ scale: 1.2 }}
              aria-label="Twitter"
            >
              <Twitter size={24} />
            </motion.a>
            <motion.a
              href="https://facebook.com"
              target="_blank"
              whileHover={{ scale: 1.2 }}
              aria-label="Facebook"
            >
              <Facebook size={24} />
            </motion.a>
          </div>
        </motion.div>

        <motion.div
          className="footer-links"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h4 className="footer-section-title">Quick Links</h4>
          <ul className="footer-links-list">
            <motion.li whileHover={{ x: 5 }}>
              <a href="#products">Products</a>
            </motion.li>
            <motion.li whileHover={{ x: 5 }}>
              <a href="#gallery">Gallery</a>
            </motion.li>
            <motion.li whileHover={{ x: 5 }}>
              <a href="#about">About</a>
            </motion.li>
            <motion.li whileHover={{ x: 5 }}>
              <a href="#contact">Contact</a>
            </motion.li>
          </ul>
        </motion.div>

        <motion.div
          className="footer-contact"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <h4 className="footer-section-title">Contact Us</h4>
          <ul className="footer-contact-list">
            <motion.li className="contact-item" whileHover={{ x: 5 }}>
              <MapPin className="contact-icon" size={20} />
              <span>UNIT H2C, Deseronto Estate, St. Mary Road, Slough, Berkshire, SL3 7EW</span>
            </motion.li>
            <motion.li className="contact-item" whileHover={{ x: 5 }}>
              <Phone className="contact-icon" size={20} />
              <a href="tel:+447304083286">07304 083286</a>
            </motion.li>
            <motion.li className="contact-item" whileHover={{ x: 5 }}>
              <Mail className="contact-icon" size={20} />
              <a href="mailto:nirupal92@gmail.com">nirupal92@gmail.com</a>
            </motion.li>
          </ul>
        </motion.div>

        <motion.div
          className="footer-newsletter"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <h4 className="footer-section-title">Stay Updated</h4>
          <p className="newsletter-description">
            Subscribe for exclusive offers and printing tips.
          </p>
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              className="newsletter-input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <motion.button
              type="submit"
              className="newsletter-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Subscribe
            </motion.button>
          </form>
          {subscribed && (
            <motion.p
              className="newsletter-success"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              Subscribed! Check your inbox for updates.
            </motion.p>
          )}
        </motion.div>
      </div>
      <motion.div
        className="footer-bottom"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.8 }}
        viewport={{ once: true }}
      >
        <p className="footer-copyright">
          &copy; 2025 NIRUPRINT SOLUTIONS. All rights reserved.
        </p>
      </motion.div>
    </footer>
  );
};

export default Footer;